var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { useMemo } from "react";
import { normalizeHref, uuid } from "./../../wix-rich-content-common";
function convertToGalleryItems(items, relValue, anchorTarget) {
  return items.map((item, index) => {
    var _a, _b, _c, _d;
    const { image, video, title, altText } = item;
    const media = (image == null ? void 0 : image.media) || (video == null ? void 0 : video.media);
    const mediaUrl = ((_a = media == null ? void 0 : media.src) == null ? void 0 : _a.url) || ((_b = media == null ? void 0 : media.src) == null ? void 0 : _b.id) || "";
    const width = (media == null ? void 0 : media.width) || 0;
    const height = (media == null ? void 0 : media.height) || 0;
    const convertedData = {
      mediaUrl,
      url: mediaUrl,
      metaData: {
        type: image ? "image" : "video",
        height,
        width,
        title,
        alt: altText
      }
    };
    if (video) {
      convertedData.metaData.link = {
        target: "_blank",
        rel: "noopener",
        url: (_c = normalizeHref(mediaUrl)) != null ? _c : ""
      };
      const { src, width: thumbnailWidth, height: thumbnailHeight } = video.thumbnail || {};
      if (src == null ? void 0 : src.url) {
        convertedData.metaData.poster = {
          url: src.url,
          width: thumbnailWidth || width,
          height: thumbnailHeight || height
        };
      }
    }
    if (image == null ? void 0 : image.link) {
      const { url: linkUrl = "", target: linkTarget, rel: linkRel } = image.link;
      const target = linkTarget && `_${linkTarget.toLowerCase()}` || anchorTarget || "_self";
      const url = (_d = normalizeHref(linkUrl)) != null ? _d : "";
      let rel = relValue || "noopener";
      if (linkRel) {
        rel = "noopener";
        linkRel.nofollow && (rel += " nofollow");
        linkRel.sponsored && (rel += " sponsored");
        linkRel.ugc && (rel += " ugc");
        (linkRel.noreferrer || linkRel.noreferrer === void 0) && (rel += " noreferrer");
      }
      convertedData.metaData.link = {
        type: "wix",
        target,
        data: {
          type: "ExternalLink",
          target,
          rel,
          url
        }
      };
      convertedData.directLink = {
        url,
        target,
        rel
      };
    }
    return __spreadProps(__spreadValues({}, convertedData), {
      // uuid is used to guarentee there are no 2 gallery items on the DOM with the same ID (on different galleries) due to a pro gallery issues with videos - breaks the video controls behavoiur.
      itemId: uuid() + "_" + index.toString(),
      hash: mediaUrl + "_" + index.toString()
    });
  });
}
function useItems(items, relValue, anchorTarget) {
  const galleryItems = useMemo(() => {
    return convertToGalleryItems(items, relValue, anchorTarget);
  }, [items]);
  return galleryItems;
}
export {
  convertToGalleryItems,
  useItems
};
//# sourceMappingURL=useItems.js.map
